import React, { useState } from 'react';
import { Select, SelectProps } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import styles from './TemplateOptions.module.scss';

const { Option } = Select;

interface TemplateOptionsProps {
  options: Array<{
    id: string;
    contract_template_name: string;
    term_sheet_template_name: string;
  }>;
  onChange?: (value: string, template: any) => void;
  selectedValue: string;
  disabled: boolean;
}

const TemplateOptions: React.FC<TemplateOptionsProps> = ({ options = [], onChange, selectedValue, disabled }) => {
  const handleChange = (value: string) => {
    const selectedTemplate = options?.find(option => option.id === value);
    if (onChange && selectedTemplate) {
      onChange(value, selectedTemplate);
    }
  };

  const filterOption: SelectProps['filterOption'] = (input, option) => {
    return option?.children
      ? String(option.children).toLowerCase().includes(input.toLowerCase())
      : false;
  };

  return (
    <div className={styles.templateOptionsContainer}>
      <Select
        showSearch
        className={styles.customSelect}
        placeholder="Search Template"
        value={selectedValue}
        onChange={handleChange}
        optionFilterProp="children"
        filterOption={filterOption}
        dropdownClassName={styles.customDropdown}
        suffixIcon={<CaretDownFilled style={{ color: '#1D1B20' }} />}
        disabled={disabled}
      >
        {options?.map((option) => (
          <Option key={option.id} value={option.id}  disabled={option.contract_template_name === "SOW" || option.contract_template_name === "MSOW"}>
            {option.contract_template_name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default TemplateOptions;
